import React from 'react'
import { useNavigate } from 'react-router-dom'

const C = {
  g900:'#0D2218', g800:'#1A3A28', g700:'#235233', g600:'#2D6B42',
  g500:'#3D8A57', g400:'#5AAE73', g300:'#85C99A', g100:'#E8F5EE', g50:'#F2FAF5',
  white:'#FFFFFF', text:'#1A2820', muted:'#5A7065', border:'#C8DDD2',
}

const SERVICES = [
  {
    icon:'⚡', name:'Laser Toning',
    desc:'Even skin tone and reduce pigmentation with advanced laser technology.',
    details:['Targets melanin deposits','Minimal downtime','Suitable for all skin types','3–6 sessions recommended'],
    badge:'Popular',
  },
  {
    icon:'✨', name:'Chemical Peels',
    desc:'Safe, medically supervised peels to improve skin texture and reveal a healthy glow.',
    details:['Superficial to deep peels','Treats acne, pigmentation, ageing','Customised to skin type','Post-peel care included'],
  },
  {
    icon:'🩹', name:'Acne Management',
    desc:'Comprehensive medical and cosmetic treatment pathways for acne and acne scars.',
    details:['Prescription-based regimens','Comedone extraction','LED therapy options','Scar reduction protocols'],
    badge:'Bestseller',
  },
  {
    icon:'💆', name:'Hair Loss Treatment',
    desc:'Advanced diagnostics and targeted therapies for all types of hair loss.',
    details:['PRP hair therapy','Minoxidil protocols','Nutritional analysis','Hair transplant consultations'],
  },
  {
    icon:'🌿', name:'Eczema & Psoriasis',
    desc:'Specialist management of chronic skin conditions for long-term relief.',
    details:['Personalised flare management','Topical & systemic options','Lifestyle guidance','Ongoing follow-up care'],
  },
  {
    icon:'⏳', name:'Anti-Ageing',
    desc:'Evidence-based rejuvenation therapies to restore youthful, firm, glowing skin.',
    details:['Botox & fillers consultation','Retinol-based regimens','Collagen boosting treatments','Preventive skincare planning'],
  },
  {
    icon:'🔬', name:'Mole & Lesion Check',
    desc:'Expert dermatological assessment of moles, lesions, and suspicious skin changes.',
    details:['Dermoscopy screening','Biopsy if needed','Digital documentation','Annual review plans'],
  },
  {
    icon:'💊', name:'Prescription Skincare',
    desc:'Doctor-written prescriptions for medically-grade skincare products delivered to your door.',
    details:['Tretinoin, Clindamycin & more','Personalised regimen','Free delivery','Monthly follow-up included'],
    badge:'New',
  },
]

function ServiceCard({ service }) {
  const [hov, setHov] = React.useState(false)
  const navigate = useNavigate()

  return (
    <div
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      style={{
        background: hov ? `linear-gradient(135deg, ${C.g700}, ${C.g500})` : 'white',
        border: `1px solid ${hov ? C.g500 : C.border}`,
        borderRadius: 20,
        padding: '2rem',
        transition: 'all .35s cubic-bezier(.4,0,.2,1)',
        cursor: 'pointer',
        boxShadow: hov ? '0 16px 48px rgba(45,107,66,.2)' : '0 2px 8px rgba(13,34,24,.04)',
        transform: hov ? 'translateY(-6px)' : 'none',
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
      }}
    >
      {/* Icon + badge row */}
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
        <div style={{
          width: 52, height: 52, borderRadius: 14,
          background: hov ? 'rgba(255,255,255,.15)' : C.g100,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: '1.5rem', transition: 'background .35s',
        }}>
          {service.icon}
        </div>
        {service.badge && (
          <span style={{
            background: hov ? 'rgba(255,255,255,.15)' : C.g700,
            color: hov ? 'white' : 'white',
            fontSize: '.6rem', fontWeight: 600, padding: '3px 10px',
            borderRadius: 999, letterSpacing: '.08em', border: hov ? '1px solid rgba(255,255,255,.3)' : 'none',
          }}>
            {service.badge.toUpperCase()}
          </span>
        )}
      </div>

      {/* Title & desc */}
      <div>
        <h3 style={{
          fontFamily: "'DM Serif Display', serif", fontSize: '1.2rem',
          color: hov ? 'white' : C.g900, marginBottom: '.5rem', transition: 'color .35s',
        }}>
          {service.name}
        </h3>
        <p style={{
          fontSize: '.85rem', color: hov ? 'rgba(255,255,255,.7)' : C.muted,
          lineHeight: 1.7, transition: 'color .35s',
        }}>
          {service.desc}
        </p>
      </div>

      {/* Bullet details */}
      <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '.4rem' }}>
        {service.details.map((d, i) => (
          <li key={i} style={{
            display: 'flex', alignItems: 'center', gap: 8,
            fontSize: '.78rem', color: hov ? 'rgba(255,255,255,.65)' : C.muted,
            transition: 'color .35s',
          }}>
            <span style={{
              width: 5, height: 5, borderRadius: '50%', flexShrink: 0, display: 'inline-block',
              background: hov ? 'rgba(255,255,255,.5)' : C.g500,
              transition: 'background .35s',
            }} />
            {d}
          </li>
        ))}
      </ul>

      {/* CTA */}
      <div style={{ marginTop: 'auto', paddingTop: '.75rem' }}>
        <button
          onClick={() => navigate('/book-appointment')}
          style={{
            width: '100%', padding: '.6rem', borderRadius: 9,
            background: hov ? 'rgba(255,255,255,.15)' : C.g50,
            color: hov ? 'white' : C.g700,
            border: `1px solid ${hov ? 'rgba(255,255,255,.3)' : C.border}`,
            fontSize: '.78rem', fontWeight: 600, cursor: 'pointer',
            fontFamily: "'DM Sans', sans-serif", letterSpacing: '.04em',
            transition: 'all .35s',
          }}
        >
          Book This Service →
        </button>
      </div>
    </div>
  )
}

export default function Services() {
  const navigate = useNavigate()

  return (
    <div style={{ background: 'white', minHeight: '100vh' }}>

      {/* Page Hero */}
      <div style={{
        background: `linear-gradient(145deg, ${C.g900}, ${C.g800}, ${C.g700})`,
        padding: '2.4rem 2rem 2.2rem',
        position: 'relative', overflow: 'hidden',
      }}>
        <div style={{ position:'absolute', inset:0, backgroundImage:`radial-gradient(circle, rgba(255,255,255,.025) 1px, transparent 1px)`, backgroundSize:'28px 28px', pointerEvents:'none' }} />
        <div style={{ position:'absolute', right:'-5%', top:'-20%', width:400, height:400, borderRadius:'50%', background:`radial-gradient(circle,rgba(93,174,115,.12) 0%,transparent 65%)`, pointerEvents:'none' }} />

        <div style={{ maxWidth: 1600, margin: '0 auto', position: 'relative', zIndex: 1 }}>
          <div style={{
            display: 'inline-flex', alignItems: 'center', gap: 8,
            background: 'rgba(255,255,255,.08)', border: '1px solid rgba(255,255,255,.15)',
            borderRadius: 999, padding: '.35rem 1rem', marginBottom: '.9rem',
          }}>
            <span style={{ width: 6, height: 6, borderRadius: '50%', background: C.g300, display: 'inline-block' }} />
            <span style={{ fontSize: '.72rem', color: 'rgba(255,255,255,.7)', letterSpacing: '.14em', textTransform: 'uppercase' }}>
              Specialist Care
            </span>
          </div>
          <h1 style={{
            fontFamily: "'DM Serif Display', serif",
            fontSize: 'clamp(1.7rem,3.5vw,2.4rem)',
            color: 'white', lineHeight: 1.1, marginBottom: '.7rem',
          }}>
            Skin & Hair Services
          </h1>
          <p style={{
            fontSize: '.92rem', color: 'rgba(255,255,255,.6)',
            maxWidth: 520, lineHeight: 1.6, marginBottom: '1.3rem', fontWeight: 300,
          }}>
            Evidence-based dermatological treatments delivered by certified specialists. Every plan is personalised — no cookie-cutter protocols.
          </p>
          <button
            onClick={() => navigate('/book-appointment')}
            style={{
              background: C.g400, color: C.g900, padding: '.85rem 2rem',
              borderRadius: 10, fontSize: '.875rem', fontWeight: 600,
              border: 'none', cursor: 'pointer',
              fontFamily: "'DM Sans', sans-serif", letterSpacing: '.04em',
              boxShadow: '0 4px 20px rgba(90,174,115,.35)', transition: 'all .2s',
            }}
          >
            Book a Consultation — ₹500
          </button>
        </div>
      </div>

      {/* Services Grid */}
      <div style={{ maxWidth: 1600, margin: '0 auto', padding: '4.5rem 2rem' }}>
        <div style={{ marginBottom: '3rem' }}>
          <div style={{
            fontSize: '.68rem', letterSpacing: '.18em', textTransform: 'uppercase',
            color: C.g600, marginBottom: '.65rem', display: 'flex', alignItems: 'center', gap: 10,
          }}>
            <span style={{ display: 'inline-block', width: 28, height: 1.5, background: C.g500 }} />
            What We Treat
          </div>
          <h2 style={{
            fontFamily: "'DM Serif Display', serif",
            fontSize: 'clamp(1.8rem,3.5vw,2.75rem)', color: C.g900, lineHeight: 1.15,
          }}>
            All Services
          </h2>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
          gap: '1.5rem',
        }}>
          {SERVICES.map(sv => <ServiceCard key={sv.name} service={sv} />)}
        </div>
      </div>

      {/* Bottom CTA */}
      <div style={{ background: C.g50, padding: '0 2rem 5rem' }}>
        <div style={{ maxWidth: 1600, margin: '0 auto' }}>
          <div style={{
            background: `linear-gradient(130deg, ${C.g900}, ${C.g700})`,
            borderRadius: 24, padding: '3.5rem 4rem',
            display: 'flex', justifyContent: 'space-between',
            alignItems: 'center', gap: '2rem', flexWrap: 'wrap',
          }}>
            <div>
              <h2 style={{
                fontFamily: "'DM Serif Display', serif",
                fontSize: 'clamp(1.6rem,3vw,2.25rem)',
                color: 'white', marginBottom: '.75rem', lineHeight: 1.2,
              }}>
                Not sure which service<br />you need?
              </h2>
              <p style={{ color: 'rgba(255,255,255,.6)', fontSize: '.9rem', maxWidth: 380, lineHeight: 1.75 }}>
                Book a general consultation for just ₹500 and our dermatologist will guide you to the right treatment.
              </p>
            </div>
            <button
              onClick={() => navigate('/book-appointment')}
              style={{
                background: C.g400, color: C.g900,
                padding: '.9rem 2.25rem', borderRadius: 10,
                fontSize: '.875rem', fontWeight: 600, border: 'none', cursor: 'pointer',
                fontFamily: "'DM Sans', sans-serif", letterSpacing: '.04em',
                boxShadow: '0 4px 20px rgba(90,174,115,.35)', flexShrink: 0,
              }}
            >
              Book Consultation — ₹500
            </button>
          </div>
        </div>
      </div>

    </div>
  )
}

